module.exports = __webpack_public_path__ + "img/female-infant-head.cb5d732b.svg";